import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import AdjustmentsVerticalSvg from '@/assets/AdjustmentsVertical.svg';

const AdjustmentsVertical = ({ size, variant, className }: IconProps) => (
  <img
    src={AdjustmentsVerticalSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default AdjustmentsVertical;
